import React from 'react';

/**
 * The one screen an installed app below the server's minimum build shows (backend client_compat.py). It never
 * half-works against an API it does not know: it says so and points at the store.
 */
export default function UpdateRequired({ client }) {
  const store = client?.kind === 'ios' ? 'the App Store' : 'Google Play';
  return (
    <main className="min-h-screen flex items-center justify-center px-6" data-testid="update-required">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold text-gray-900">Update the app</h1>
        <p className="mt-3 text-gray-600">
          This version ({client?.app_version || 'unknown'}) is older than the server supports
          ({client?.min_app_version}). Update it from {store} to carry on. Nothing you have saved is lost.
        </p>
      </div>
    </main>
  );
}
